{
	"id": 7507,
	"moduleNumber": 7,
	"title": "The Professional Educator and AI",
	"subtitle": "Use AI responsibly by maintaining oversight, protecting privacy, ensuring transparency, and prioritizing student welfare.",
	"kgNodeId": "module-7",
	"moduleKind": "ai_simulation",
	"moduleKindLabel": "AI Simulation",
	"summary": "Module 7 introduces AI-related educator ethics through three simulation scenarios: data privacy, human-in-the-loop decision making, and social media. Learners evaluate how professional responsibilities apply when AI tools influence student data, instructional decisions, and educator communication.",
	"estimatedDurationMinutes": 50,
	"activityCount": 3,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	}
}
